<template>
  <v-container
    class="common-section-wrapper"
    fluid
    :style="
      data.color
        ? { 'background-color': data.color }
        : {
            'background-image':
              'url(' +
              require('@/assets/images/homepage/' + data.background) +
              ')',
          }
    "
  >
    <v-row>
      <v-col class="col-12 col-md-5 pa-md-0" offset-md="1">
        <h2 v-html="data.title"></h2>
        <h5 v-if="data.subtitle" v-html="data.subtitle"></h5>
        <p v-html="data.text"></p>
        <template v-if="Array.isArray(data.button) === true">
          <a
            v-for="(button, i) in data.button"
            :key="i"
            :href="button.url"
            :target="button.external_url === true ? '_blank' : '_self'"
            :style="{ background: button.color ? button.color : '' }"
            class="button multi"
            >{{ button.text }}</a
          >
        </template>
        <a
          v-else
          :href="data.button.url"
          :target="data.button.external_url === true ? '_blank' : '_self'"
          :style="{ background: data.button.color ? data.button.color : '' }"
          class="button"
          >{{ data.button.text }}</a
        >
      </v-col>
      <v-col class="col-12 col-md-5 pa-md-0 right-side" offset-md="1">
        <img :src="require('@/assets/images/businesses-pages/' + data.image)" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CommonSection2Businesses',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.common-section-wrapper
  position: relative
  min-height: 700px
  padding-top: 160px
  overflow: hidden
  &:before
    background: url("~@/assets/images/homepage/common-section-floating-element01.png") no-repeat center center
    content: ''
    position: absolute
    display: block
    width: 520px
    height: 108px
    bottom: 0
    right: 0
    transform: scaleX(-1)
    z-index: 2
  h2,
  h5
    font-style: normal
    color: #003036
    line-height: 1.4
  h5,
  p
    font-family: 'metropolisregular'
    font-weight: 400
    font-size: 18px
    line-height: 1
    ::v-deep
      span
        font-family: 'metropolisbold'
        font-style: normal
        font-weight: 700
  h2
    font-family: 'metropolissemi_bold'
    font-weight: 600
    font-size: 48px
    margin-bottom: 25px
    text-shadow: 0.5px 0.5px #003036
    ::v-deep
      span
        font-family: 'metropolisregular'
        font-weight: 400
  p
    color: #72737A
    margin-bottom: 50px
  .button
    background: #003036
    position: relative
    display: inline-block
    font-family: 'metropolisbold'
    font-style: normal
    font-weight: 700
    font-size: 16px
    line-height: 24px
    text-transform: uppercase
    color: #FFFFFF
    align-items: center
    text-align: center
    padding: 8px 48px
    border-radius: 20px
    outline: none
    text-decoration: none
    transition: all 0.3s ease-in-out
    width:192px
    &:hover
      background: #3DCF8E
      transition: all 0.3s ease-in-out
    &.multi
      margin-right: 20px
      @media screen and (min-width: 320px) and (max-width: 915px)
      margin:5px
  .right-side
    img
      position: absolute
      right: 0
      z-index: 1
  @media screen and (max-width: 959px)
    min-height: 800px
    padding-top: 70px
    &:before
      display: none
    h2
      font-size: 24px
    p
      margin-bottom: 25px
</style>
